import { insertIntoArray } from '../utils';
import {
  buildAdditionalContactCard,
  type ContactCardOverrides,
} from './additionalContactCard';

export const buildTitleOfficerCard = () => {
  return buildAdditionalContactCard({
    contactType: 'titleOfficer',
    contactLabel: 'Title',
    overrides: {
      hideByDefault: false,
      displayFields: (defaultFields) =>
        insertIntoArray(defaultFields, 1, {
          name: 'contacts.titleOfficer.x.titleNumber',
          type: 'default',
        }),
      layout: (defaultLayout) =>
        insertIntoArray(defaultLayout, 1, [
          {
            name: 'contacts.titleOfficer.x.titleNumber',
            size: 100,
          },
        ]),
      fields: {
        role: {
          label: 'Role',
          placeholderText: 'Title Officer, Assistant, etc',
        },
        titleNumber: {
          name: 'contacts.titleOfficer.x.titleNumber',
          entity: 'contacts',
          entityType: 'titleOfficer',
          type: 'text',
          label: 'Title Number/GFN',
          placeholderText: '',
        },
      },
    } satisfies ContactCardOverrides,
  });
};
